import Link from "../../components/Link";
import { useAsyncLoadImage } from "../../utils/hooks/useAsyncLoadImage";

interface IRecommendedRandomCardProps {
  card: ArticleResponse;
}
export const RecommendedRandomCard = ({
  card,
}: IRecommendedRandomCardProps) => {
  const imageUrl = useAsyncLoadImage(card.cover_image);

  return (
    <div className="card card-row another-cards__card">
      <div className="card__media">
        <span
          className="card__media-pic"
          style={{ backgroundImage: imageUrl ? `url(${imageUrl})` : undefined }}
        >
          {!imageUrl && <div className="skeleton"></div>}
        </span>
      </div>
      <div className="card__body">
        <Link className="card__title" to={card.article_index}>
          {card.article_name}
        </Link>
      </div>
    </div>
  );
};
